import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

export const LABEL_DAYS = {
  7: 'SEVEN_DAYS',
  15: 'FIFTEEN_DAYS',
  30: 'THIRTY_DAYS',
  CUSTOM: 'CUSTOM',
  UNDEFINED: 'UNDEFINED'
};

const common = {
  event: GA.EVENTS.INTERACTION,
  event_category: GA.CATEGORIES.CLUB_ADMIN_CONTENT
};

const DRIPPING_BULK_ACTION_SCHEDULE_EVENTS = GtagService.createEvents({
  common,
  [GA.LABELS.SCHEDULE]: {
    event_label: GA.LABELS.SCHEDULE,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_SCHEDULE
  }
});

const DRIPPING_BULK_ACTION_TOOLTIP_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.HOVER_TOOLTIP
  },
  [GA.LABELS.EXPIRATION]: {
    event_label: GA.LABELS.EXPIRATION
  },
  [GA.LABELS.DRIPPING_BY_DAYS]: {
    event_label: GA.LABELS.DRIPPING_BY_DAYS
  },
  [GA.LABELS.DRIPPING_BY_DATE]: {
    event_label: GA.LABELS.DRIPPING_BY_DATE
  }
});

const DRIPPING_BULK_ACTION_REMOVE_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_REMOVE
  },
  [GA.LABELS.REMOVE]: {
    event_label: GA.LABELS.REMOVE
  },
  [GA.LABELS.CANCEL]: {
    event_label: GA.LABELS.CANCEL
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  }
});

const DRIPPING_BULK_ACTION_DAY_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_DAY
  },
  [GA.LABELS.UNDEFINED]: {
    event_label: GA.LABELS.UNDEFINED
  },
  [GA.LABELS.SEVEN_DAYS]: {
    event_label: GA.LABELS.SEVEN_DAYS
  },
  [GA.LABELS.FIFTEEN_DAYS]: {
    event_label: GA.LABELS.FIFTEEN_DAYS
  },
  [GA.LABELS.THIRTY_DAYS]: {
    event_label: GA.LABELS.THIRTY_DAYS
  },
  [GA.LABELS.CUSTOM]: {
    event_label: GA.LABELS.CUSTOM
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  }
});

const DRIPPING_BULK_ACTION_DAY_CUSTOM_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_DAY_CUSTOM
  },
  [GA.LABELS.SAVE]: {
    event_label: GA.LABELS.SAVE
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  }
});

const DRIPPING_BULK_ACTION_DATE_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_DATE
  },
  [GA.LABELS.CANCEL]: {
    event_label: GA.LABELS.CANCEL
  },
  [GA.LABELS.SAVE]: {
    event_label: GA.LABELS.SAVE
  },
  [GA.LABELS.SELECT_YEAR]: {
    event_label: GA.LABELS.SELECT_YEAR
  },
  [GA.LABELS.SELECT_MONTH]: {
    event_label: GA.LABELS.SELECT_MONTH
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  },
  [GA.LABELS.REMOVE]: {
    event_label: GA.LABELS.REMOVE
  }
});

const DRIPPING_BULK_ACTION_EXPIRATION_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_EXPIRATION
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  },
  [GA.LABELS.UNDEFINED]: {
    event_label: GA.LABELS.UNDEFINED
  },
  [GA.LABELS.SEVEN_DAYS]: {
    event_label: GA.LABELS.SEVEN_DAYS
  },
  [GA.LABELS.FIFTEEN_DAYS]: {
    event_label: GA.LABELS.FIFTEEN_DAYS
  },
  [GA.LABELS.THIRTY_DAYS]: {
    event_label: GA.LABELS.THIRTY_DAYS
  },
  [GA.LABELS.CUSTOM]: {
    event_label: GA.LABELS.CUSTOM
  }
});

const DRIPPING_BULK_ACTION_EXPIRATION_CUSTOM_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.DRIPPING_BULK_ACTION.CLICK_EXPIRATION_CUSTOM
  },
  [GA.LABELS.BACK]: {
    event_label: GA.LABELS.BACK
  },
  [GA.LABELS.SAVE]: {
    event_label: GA.LABELS.SAVE
  }
});

export const clickScheduleButton = () => {
  const event = DRIPPING_BULK_ACTION_SCHEDULE_EVENTS[GA.LABELS.SCHEDULE];

  event && window.dataLayer.push(event);
};

export const hoverExpirationDays = () => {
  const event = DRIPPING_BULK_ACTION_TOOLTIP_EVENTS[GA.LABELS.EXPIRATION];

  event && window.dataLayer.push(event);
};

export const hoverDrippingDayDate = (type) => {
  const LABEL = `DRIPPING_${type}`;
  const event = DRIPPING_BULK_ACTION_TOOLTIP_EVENTS[GA.LABELS[LABEL]];

  event && window.dataLayer.push(event);
};

export const clickRemove = () => {
  const event = DRIPPING_BULK_ACTION_REMOVE_EVENTS[GA.LABELS.REMOVE];

  event && window.dataLayer.push(event);
};

export const clickCancelRemove = () => {
  const event = DRIPPING_BULK_ACTION_REMOVE_EVENTS[GA.LABELS.CANCEL];

  event && window.dataLayer.push(event);
};

export const clickPreviousStep = ({ active, options }) => {
  const TYPE = {
    BY_DAYS_SELECTOR:
      options.type === 'EXPIRATION'
        ? DRIPPING_BULK_ACTION_EXPIRATION_EVENTS
        : DRIPPING_BULK_ACTION_DAY_EVENTS,
    BY_DATE_SELECTOR: DRIPPING_BULK_ACTION_DATE_EVENTS,
    REMOVE_DRIPPING_SELECTOR: DRIPPING_BULK_ACTION_REMOVE_EVENTS,
    CUSTOM_DAYS_SELECTOR:
      options.type === 'EXPIRATION'
        ? DRIPPING_BULK_ACTION_EXPIRATION_CUSTOM_EVENTS
        : DRIPPING_BULK_ACTION_DAY_CUSTOM_EVENTS
  };

  const event = TYPE[active][GA.LABELS.BACK];

  event && window.dataLayer.push(event);
};

export const clickDaysSelector = (days) => {
  const event = DRIPPING_BULK_ACTION_DAY_EVENTS[GA.LABELS[LABEL_DAYS[days]]];

  event && window.dataLayer.push(event);
};

export const clickSaveCustomDays = (value) => {
  const event = {
    ...DRIPPING_BULK_ACTION_DAY_CUSTOM_EVENTS[GA.LABELS.SAVE],
    event_detail: value
  };

  event && window.dataLayer.push(event);
};

export const clickSaveDate = () => {
  const event = DRIPPING_BULK_ACTION_DATE_EVENTS[GA.LABELS.SAVE];

  event && window.dataLayer.push(event);
};

export const clickCancelDate = () => {
  const event = DRIPPING_BULK_ACTION_DATE_EVENTS[GA.LABELS.CANCEL];

  event && window.dataLayer.push(event);
};

export const clickMonthDate = () => {
  const event = DRIPPING_BULK_ACTION_DATE_EVENTS[GA.LABELS.SELECT_MONTH];

  event && window.dataLayer.push(event);
};

export const clickYearDate = () => {
  const event = DRIPPING_BULK_ACTION_DATE_EVENTS[GA.LABELS.SELECT_YEAR];

  event && window.dataLayer.push(event);
};

export const clickExpirationDaysSelector = (days) => {
  const event =
    DRIPPING_BULK_ACTION_EXPIRATION_EVENTS[GA.LABELS[LABEL_DAYS[days]]];

  event && window.dataLayer.push(event);
};

export const clickSaveCustomExpiration = (value) => {
  const event = {
    ...DRIPPING_BULK_ACTION_EXPIRATION_CUSTOM_EVENTS[GA.LABELS.SAVE],
    event_detail: value
  };

  event && window.dataLayer.push(event);
};
